export const name = "ST_UNION_AGG";
export const summary = `Aggregates over \`GEOGRAPHY\` values and gets their point set union.`;
export const reference = `
## ST_UNION_AGG

Aggregates over \`GEOGRAPHY\` values and gets their point set union.

\`\`\`
ST_UNION_AGG(geography)
\`\`\`

### Description

Returns a \`GEOGRAPHY\` that represents the point set union of all input \`GEOGRAPHY\`s.

\`ST_UNION_AGG\` ignores \`NULL\` input \`GEOGRAPHY\` values.

See \`ST_UNION\` for the non-aggregate version of \`ST_UNION_AGG\`.


### Return type

\`GEOGRAPHY\`


### Example



\`\`\`
SELECT ST_UNION_AGG(items) AS results
FROM UNNEST([
  ST_GEOGFROMTEXT('LINESTRING(-122.12 47.67, -122.19 47.69)'),
  ST_GEOGFROMTEXT('LINESTRING(-122.12 47.67, -100.19 47.69)'),
  ST_GEOGFROMTEXT('LINESTRING(-122.12 47.67, -122.19 47.69)')]) as items;

/*---------------------------------------------------------*
 | results |
 +---------------------------------------------------------+
 | LINESTRING(-100.19 47.69, -122.12 47.67, -122.19 47.69) |
 *---------------------------------------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
